var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGlobal = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bold / Map & Location / Global"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.03125 11.25C2.41478 6.07745 6.73299 2 12.0035 2C11.1727 2 10.4329 2.36421 9.82435 2.92113C9.21883 3.47525 8.70713 4.24878 8.29325 5.16315C7.87693 6.08292 7.55355 7.15868 7.33467 8.32611C7.15922 9.26194 7.05244 10.2485 7.01685 11.25H2.03125ZM2.03125 12.75H7.01685C7.05244 13.7515 7.15922 14.7381 7.33467 15.6739C7.55355 16.8413 7.87693 17.9171 8.29325 18.8368C8.70712 19.7512 9.21883 20.5247 9.82435 21.0789C10.4329 21.6358 11.1727 22 12.0035 22C6.73299 22 2.41478 17.9226 2.03125 12.75Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0035 3.39535C11.7285 3.39535 11.3733 3.51236 10.9602 3.89042C10.544 4.27126 10.1274 4.86815 9.75926 5.68137C9.39361 6.4892 9.09671 7.46441 8.89239 8.55419C8.73148 9.41242 8.63166 10.3222 8.59663 11.25H15.4105C15.3754 10.3222 15.2756 9.41242 15.1147 8.5542C14.9104 7.46441 14.6135 6.48921 14.2478 5.68137C13.8797 4.86815 13.4631 4.27126 13.0469 3.89042C12.6338 3.51236 12.2786 3.39535 12.0035 3.39535Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.89239 15.4458C9.0967 16.5356 9.39361 17.5108 9.75926 18.3186C10.1274 19.1319 10.544 19.7287 10.9602 20.1096C11.3733 20.4876 11.7285 20.6047 12.0035 20.6047C12.2786 20.6047 12.6338 20.4876 13.0469 20.1096C13.4631 19.7287 13.8797 19.1319 14.2478 18.3186C14.6135 17.5108 14.9104 16.5356 15.1147 15.4458C15.2756 14.5876 15.3754 13.6778 15.4105 12.75H8.59663C8.63166 13.6778 8.73148 14.5876 8.89239 15.4458Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0035 2C12.8344 2 13.5742 2.36421 14.1827 2.92113C14.7883 3.47525 15.3 4.24878 15.7138 5.16315C16.1302 6.08292 16.4535 7.15868 16.6724 8.32612C16.8479 9.26194 16.9547 10.2485 16.9902 11.25H21.9758C21.5923 6.07745 17.2741 2 12.0035 2Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6724 15.6739C16.4535 16.8413 16.1302 17.9171 15.7138 18.8368C15.3 19.7512 14.7883 20.5247 14.1827 21.0789C13.5742 21.6358 12.8344 22 12.0035 22C17.2741 22 21.5923 17.9226 21.9758 12.75H16.9902C16.9547 13.7515 16.8479 14.7381 16.6724 15.6739Z",
    fill: "#818181"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGlobal);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/global.68bac1f85bf080e58d988a9381509295.svg";